export class Youtube {
  title: number;
  videoId: string;

  constructor(title: number, videoId: string) {
    this.title = title;
    this.videoId = videoId;
  }
}
